import {
    LOGIN_REQUEST,
    LOGIN_RESPONSE,
    LOGIN_RESPONSE_ERROR,
    RESET_PASS_REQUEST,
    RESET_PASS_RESPONSE,
    RESET_PASS_RESPONSE_ERROR,
    LOGOUT,
    RESET_PASS_EMAIL_REQUEST,
    RESET_PASS_EMAIL_RESPONSE,
    RESET_PASS_EMAIL_RESPONSE_ERROR,
    CLEAN_RESET_PASS_EMAIL_STATE, CLEAN_RESET_PASS_STATE,
} from './login.actions';

const initialState = {
    isLoggedIn: false,
    userInfo: {
        email: '',
        isActive: '',
        status: '',
        roleId: '',
        role: undefined,
        branchId: undefined,
        featureFlag: false,
    },
    token: undefined,
    resetPasswordState: {
        loading: false,
        success: false,
        error: false,
    },
    resetPasswordEmailState: {
        loading: false,
        success: false,
        error: false,
    },
    loginState: {
        loading: false,
        success: false,
        error: false,
    },
};

const loginReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_REQUEST:
        case LOGIN_RESPONSE:
        case LOGIN_RESPONSE_ERROR:
            return {
                ...state,
                token: action.type === LOGIN_RESPONSE ? action.response.response.jwt : action.token,
                userInfo: action.type === LOGIN_RESPONSE ?
                {
                    ...action.response.response.user,
                    branchId: action.response.response.provider?.branchId,
                    salesforceProviderId: action.response.response.provider?.salesforceProviderId,
                    salesforceProviderName: action.response.response.provider?.salesforceProvider?.provider?.fullName,
                    salesforceBranchId: action.response.response.provider?.salesforceBranchId,
                    salesforceBranchName: action.response.response.provider?.salesforceProvider?.branch?.fullName ||
                        action.response.response.provider?.salesforceProvider?.branch?.address,
                    featureFlag: action.response.featureFlag || false,
                }: action.userInfo,
                isLoggedIn: action.type === LOGIN_RESPONSE,
                loginState: {
                    loading: action.type === RESET_PASS_REQUEST,
                    success: action.type === RESET_PASS_RESPONSE,
                    error: action.type === RESET_PASS_RESPONSE_ERROR && action.error,
                },
            };
        case RESET_PASS_REQUEST:
        case RESET_PASS_RESPONSE:
        case RESET_PASS_RESPONSE_ERROR:
            return {
                ...state,
                resetPasswordState: {
                    loading: action.type === RESET_PASS_REQUEST,
                    success: action.type === RESET_PASS_RESPONSE,
                    error: action.type === RESET_PASS_RESPONSE_ERROR && action.error,
                },
            };
        case RESET_PASS_EMAIL_REQUEST:
        case RESET_PASS_EMAIL_RESPONSE:
        case RESET_PASS_EMAIL_RESPONSE_ERROR:
            return {
                ...state,
              resetPasswordEmailState: {
                    loading: action.type === RESET_PASS_EMAIL_REQUEST,
                    success: action.type === RESET_PASS_EMAIL_RESPONSE,
                    error: action.type === RESET_PASS_EMAIL_RESPONSE_ERROR && action.error,
                },
            };
        case CLEAN_RESET_PASS_EMAIL_STATE:
            return {
                ...state,
                resetPasswordEmailState: initialState.resetPasswordEmailState,
            };
        case CLEAN_RESET_PASS_STATE:
            return {
                ...state,
                resetPasswordState: initialState.resetPasswordState,
            };
        case LOGOUT:
            localStorage.removeItem('name');
            localStorage.removeItem('sessionTime');
            localStorage.removeItem('lastRequest');
            localStorage.removeItem('affiliateRetry');
            localStorage.removeItem('affiliateRetryTime');
            return {
                ...state,
                isLoggedIn: false,
                token: undefined,
            };
        default: return state;
    }
};

export default loginReducer;
